import * as Sentry from '@sentry/react';
import pkg from '../package.json';
import { getEnvironment } from './shared/utils';

const environment = getEnvironment();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: `${import.meta.env.VITE_SENTRY_PROJECT}@${pkg.version}+${pkg['code-version']}`,
  environment,
  debug: environment === 'local' || environment === 'development',
  sendDefaultPii: false,
  beforeSend: (event) => {
    if (environment === 'local') {
      return null;
    }
    return event;
  },
});
